import { useErrorHandlingSlice } from 'app/error/slice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import useApi from 'services/mavapi/useApi';
import { PermissionApIsService, UserRoles } from 'services/openapi';
const useRolePermissionApi = () => {
    const [loading, setLoading] = useState(false);
    const [, setError] = useState<unknown | null>();
    const { error: apiError, handleRequest } = useApi();
    const { permissionGetUserRoles, permissionDeleteRole } =
        PermissionApIsService;
    const dispatch = useDispatch();
    const { actions } = useErrorHandlingSlice();
    const [permissionRoleData, setPermissionRoleData] = useState<UserRoles[]>([]);
    const fetchPermissionRoleList = () => {
        setLoading(true);
        handleRequest(permissionGetUserRoles())
            .then(res => {
                if (res) {
                    setPermissionRoleData(res);
                }
                setLoading(false);
            })
            .catch(() => {
                setError(apiError);
                setLoading(false);
            });
    };

    const handleDeleteRole = (roleId: string) => {
        handleRequest(permissionDeleteRole(roleId))
            .then(res => {
                if (res.code === 'RoleAlreadyAssigned') {
                    dispatch(
                        actions.dispatchToast({
                            errorTxt: 'Role Already Assigned',
                            show: true,
                            errorType: 'error',
                        }),
                    );
                } else {
                    fetchPermissionRoleList();
                    dispatch(
                        actions.dispatchToast({
                            errorTxt: 'Role Deleted Successfully',
                            show: true,
                            errorType: 'success',
                        }),
                    );
                }
            })
            .catch(() => {
                setError(apiError);
            });
    };
    return {
        loading,
        fetchPermissionRoleList,
        permissionRoleData,
        handleDeleteRole,
    };
};
export default useRolePermissionApi;
